export const DOWNLOADS_ORIGIN = 'https://digitalanarchy.com';

export type DownloadHostLink = {
  label: string;
  href: string;
};

export type DownloadMenuItem = {
  label: string;
  href: string;
  children?: DownloadHostLink[];
  /** Cloud product names that must be visible for this item to appear. */
  catalogProductNames?: string[];
};

const page = (slug: string) => `${DOWNLOADS_ORIGIN}/downloads/${slug}/`;

export const DOWNLOAD_MENU: DownloadMenuItem[] = [
  {
    label: 'Anarchy Subscriptions',
    href: `${DOWNLOADS_ORIGIN}/subscriptions/`,
    catalogProductNames: ['Anarchy All Access', 'Anarchy Single Host App'],
  },
  {
    label: 'Beauty Box Video',
    href: page('premiere-pro-and-ae-beauty-box-video'),
    catalogProductNames: ['Beauty Box Video'],
    children: [
      {
        label: 'Premiere Pro and AE',
        href: page('premiere-pro-and-ae-beauty-box-video'),
      },
      {
        label: 'Final Cut Pro',
        href: page('final-cut-pro-beauty-box-video'),
      },
      {
        label: 'Davinci Resolve | OFX',
        href: page('davinci-resolve-ofx-beauty-box-video'),
      },
      {
        label: 'Avid Media Composer',
        href: page('avid-media-composer-beauty-box-video'),
      },
    ],
  },
  {
    label: 'Beauty Box Photo',
    href: page('photoshop'),
  },
  {
    label: 'Flicker Free',
    href: page('premiere-pro-and-ae-flicker-free'),
    catalogProductNames: ['Flicker Free 3.0'],
    children: [
      {
        label: 'Premiere Pro and AE',
        href: page('premiere-pro-and-ae-flicker-free'),
      },
      {
        label: 'Final Cut Pro',
        href: page('final-cut-pro-flicker-free'),
      },
      {
        label: 'Davinci Resolve | OFX',
        href: page('davinci-resolve-ofx-flicker-free'),
      },
      {
        label: 'Avid Media Composer',
        href: page('avid-media-composer-flicker-free'),
      },
    ],
  },
  {
    label: 'Light Wrap Fantastic',
    href: page('premiere-pro-and-ae-light-wrap-fantastic'),
    catalogProductNames: ['LightWrap Fantastic'],
    children: [
      {
        label: 'Premiere Pro and AE',
        href: page('premiere-pro-and-ae-light-wrap-fantastic'),
      },
      {
        label: 'Final Cut Pro',
        href: page('final-cut-pro-light-wrap-fantastic'),
      },
    ],
  },
  {
    label: 'Samurai Sharpen',
    href: page('premiere-pro-and-ae-samurai-sharpen'),
    catalogProductNames: ['Samurai'],
    children: [
      {
        label: 'Premiere Pro and AE',
        href: page('premiere-pro-and-ae-samurai-sharpen'),
      },
      {
        label: 'Final Cut Pro',
        href: page('final-cut-pro-samurai-sharpen'),
      },
      {
        label: 'Davinci Resolve | OFX',
        href: page('davinci-resolve-ofx-samurai-sharpen'),
      },
      {
        label: 'Avid Media Composer',
        href: page('avid-media-composer-samurai-sharpen'),
      },
    ],
  },
  {
    label: 'Data Storyteller',
    href: page('premiere-pro-and-ae-data-storyteller'),
    catalogProductNames: ['Data Storyteller'],
    children: [
      {
        label: 'Premiere Pro and AE',
        href: page('premiere-pro-and-ae-data-storyteller'),
      },
      {
        label: 'Final Cut Pro',
        href: page('final-cut-pro-data-storyteller'),
      },
      {
        label: 'Davinci Resolve | OFX',
        href: page('davinci-resolve-ofx-data-storyteller'),
      },
    ],
  },
  {
    label: 'Transcriptive | PowerSearch',
    href: page('premiere-pro-and-ae-transcriptive-powersearch'),
    catalogProductNames: ['Transcriptive Rough Cutter'],
  },
  {
    label: 'EFF-IT!',
    href: page('premiere-pro-and-ae-eff-it'),
  },
  {
    label: 'ShotNotes',
    href: page('premiere-pro-and-ae-shot-notes'),
    catalogProductNames: ['ShotNotes'],
  },
];

type CatalogProductName = {
  name?: string | null;
  hidden?: boolean;
};

export const getVisibleDownloadMenu = (
  products: CatalogProductName[] | undefined,
): DownloadMenuItem[] => {
  const visibleNames = new Set(
    (products ?? [])
      .filter((product) => Boolean(product.name) && !product.hidden)
      .map((product) => product.name as string),
  );
  return DOWNLOAD_MENU.filter((item) => {
    if (!item.catalogProductNames?.length) return true;
    return item.catalogProductNames.some((name) => visibleNames.has(name));
  });
};

const footerLinkFromMenu = (item: DownloadMenuItem): DownloadHostLink => ({
  label: item.label,
  href:
    item.label === 'Anarchy Subscriptions'
      ? `${DOWNLOADS_ORIGIN}/downloads/`
      : item.href,
});

/** Footer lists products (not hosts); Anarchy Subscriptions uses /downloads/. */
export const getVisibleFooterDownloadLinks = (
  products: CatalogProductName[] | undefined,
): DownloadHostLink[] =>
  getVisibleDownloadMenu(products).map(footerLinkFromMenu);
